const defaultApiBase = `${window.location.protocol}//${window.location.hostname}:8080/v1`;
const wsProtocol = window.location.protocol === "https:" ? "wss:" : "ws:";
const defaultWsBase = `${wsProtocol}//${window.location.hostname}:34932/v1`;

export const API_BASE: string = window.__API_BASE__ || defaultApiBase;
export const WS_BASE: string = window.__WS_BASE__ || defaultWsBase;
